<template>
	<div v-parallax-fit="parallax" class="slide-sticky" id="slide-sticky">
		<img src="/themes/rise-theme/dist/images/estate/character-view/henry/09_Tape@2x.png">
	</div>
</template>

<script>
	export default {
		data() {
			return {
				parallax: [
					{
						start: 23000,
						end: 24000,
						fromStyle: { height: '0%', opacity: 1 },
           				toStyle: { height: '100%', opacity: 1 },
						easing: 'linear'
					},
					{
						start: 25000,
						end: 27000,
						fromStyle: { height: '100%', opacity: 1 },
           				toStyle: { height: '100%', opacity: 0 },
						easing: 'linear'
					}
				]
			}
		},
	}
</script>

<style lang="scss" scoped>
	.slide-sticky {
		max-width: 250px;
		position: absolute;
		top: -15px;
		left: 47%;
		width: 55px;
		opacity: 0.8;
		height: 0;
		overflow: hidden;
		transition: all 0.1s linear;
		border: 1px solid transparent;
	}

	@media screen and (max-width: 1680px) {
		.slide-sticky {
			left: 50%;
			width: 49px;
			top: 0;
		}
	}

	@media screen and (max-width: 1440px) {
		.slide-sticky {
			left: 46%;
			width: 43px;
		}
	}

	@media screen and (max-width: 1280px) {
		.slide-sticky {
			width: 30px;
			top: -3px;
		}
	}

	@media screen and (max-width: 650px) {
		.slide-sticky {
			width: 16px;
		    left: 48%;
		}
	}
</style>
